import DOMPurify from 'dompurify'

const removeUnsafeNodes = (doc: Document) => {
  doc
    .querySelectorAll('style, script, iframe, link[rel="stylesheet"], meta[http-equiv="refresh"]')
    .forEach((node) => node.remove())
}

function replaceBlockWithParagraph(doc: Document, block: Element) {
  const paragraph = doc.createElement('p')
  while (block.firstChild) paragraph.appendChild(block.firstChild)
  if (!paragraph.childNodes.length) paragraph.appendChild(doc.createElement('br'))
  block.replaceWith(paragraph)
}

export function normalizeRichTextHtml(html: string) {
  if (!html?.trim()) return ''
  if (typeof window === 'undefined') return html

  const doc = new DOMParser().parseFromString(html, 'text/html')
  removeUnsafeNodes(doc)

  doc.body.querySelectorAll('div').forEach((div) => replaceBlockWithParagraph(doc, div))

  // Wrap stray top-level text nodes (e.g. pasted plain text with line breaks).
  Array.from(doc.body.childNodes).forEach((node) => {
    if (node.nodeType !== Node.TEXT_NODE) return
    const text = node.textContent || ''
    if (!text.trim()) {
      node.remove()
      return
    }

    const paragraph = doc.createElement('p')
    text.split(/\r?\n/).forEach((line, index) => {
      if (index > 0) paragraph.appendChild(doc.createElement('br'))
      if (line) paragraph.appendChild(doc.createTextNode(line))
    })
    node.replaceWith(paragraph)
  })

  return doc.body.innerHTML
}

export function sanitizeRichTextHtml(html: string) {
  const normalized = normalizeRichTextHtml(html)
  if (!normalized || typeof window === 'undefined') return normalized

  return DOMPurify.sanitize(normalized, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'link', 'meta'],
    FORBID_ATTR: ['srcset'],
  })
}
